import React from 'react';
import {useTranslation} from 'react-i18next';

import {
  Modal,
  ModalActions,
  ModalCancelButton,
  ModalHeader,
  ModalSubmitButton,
  showModal,
} from '@edna/components';

import {ModalCenterImage, SecondaryText} from 'src/components/primitives';
import {CarefulImage} from 'src/images';

type TProps = {
  onSubmit: TEmptyFunction;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
};

const NeverViewPromptModal = React.memo<{
  closeModal: TEmptyFunction;
  onSubmit: TEmptyFunction;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
}>(({closeModal, onSubmit, title, subtitle}) => {
  const {t} = useTranslation();

  const handleSubmit = React.useCallback(() => {
    closeModal();
    onSubmit();
  }, [onSubmit, closeModal]);

  return (
    <Modal width="430px">
      <ModalHeader>{title}</ModalHeader>
      <SecondaryText>{subtitle}</SecondaryText>
      <ModalCenterImage as={CarefulImage} />
      <ModalActions>
        <ModalCancelButton onClick={handleSubmit}>
          {t('Components:neverViewButton.submitButton')}
        </ModalCancelButton>
        <ModalSubmitButton onClick={closeModal}>
          {t('Components:neverViewButton.cancelButton')}
        </ModalSubmitButton>
      </ModalActions>
    </Modal>
  );
});

export const showNeverViewPromptModal = (props: TProps) =>
  showModal((closeModal) => <NeverViewPromptModal closeModal={closeModal} {...props} />);
